import React, { useEffect, useState } from "react";
import "./WithdrawalAmount.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
// import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import axios from "axios";
import { Radio, RadioGroup, FormControlLabel, TextField } from "@mui/material";

// import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import WithdrawalTransactionDataTable from "./WithdrawalTransactionDataTable";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import { useNavigate } from "react-router-dom";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
// import NotifyMessage from "../../Others/NotifyMessage";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function WithdrawalAmount() {
  const {
    RendomTokenfetch,
    walletbalance,
    userID,
    webSetting,
    profileData,
    fetchWalletBalance,
  } = useAuth();
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const maxLimit = Number(webSetting?.withdrawal_max_amount || 1000);
  const minLimit = Number(webSetting?.withdrawal_min_amount || 50);

  const [PaymentMethod, setPaymentMethod] = useState([]);
  const [PaymentMode, setPaymentMode] = useState("");

  useEffect(() => {
    if (walletbalance) {
      setAmount(walletbalance || "");
    }
  }, [walletbalance]);

  const handlePaymentMethodChange = (event) => {
    setPaymentMode(event.target.value);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value === "" || (/^\d+$/.test(value) && value.length <= 4)) {
      setAmount(value);
    } else {
      NotifyMessageNoReload(
        "Only numbers (max 4 digits) allowed!",
        "danger",
        true
      );
    }
  };

  // *********Fetch paymentMethod********
  useEffect(() => {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    const FetchVendorStatusData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}paymentmethod`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setPaymentMethod(response.data.payment_method || []);
            }
            if (response.data.Status === "0") {
              setPaymentMethod([]);
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
      }
    };
    FetchVendorStatusData();
  }, [RendomTokenfetch, userID]);

  // **************Handle Payment Submit************
  const handlePaymentSubmit = async (event) => {
    event.preventDefault();
    if (
      !profileData.bank_name ||
      !profileData.account_number ||
      !profileData.account_holder ||
      !profileData.upiId ||
      !profileData.ifsc_code
    ) {
      NotifyMessageNoReload("Please Update Your Account Details!", "danger");
      setTimeout(() => {
        navigate("/account-details-update", {
          state: { returnTo: "/withdrawal-amount" },
        });
      }, 1000);

      return;
    }

    if (!amount) {
      return NotifyMessageNoReload("Please enter an amount", "danger", true);
    }

    if (!PaymentMode) {
      return NotifyMessageNoReload(
        "Please select a Payment Method!",
        "danger",
        true
      );
    }

    const numericAmount = Number(amount);
    if (numericAmount < minLimit) {
      return NotifyMessageNoReload(
        `Minimum withdrawal is ₹${minLimit}`,
        "danger",
        true
      );
    }
    if (numericAmount > walletbalance) {
      return NotifyMessageNoReload("Insufficient balance", "danger", true);
    }
    if (numericAmount > maxLimit) {
      return NotifyMessageNoReload(
        `Maximum withdrawal limit is ₹${maxLimit}`,
        "danger",
        true
      );
    }

    setIsProcessing(true);
    try {
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("amount", amount);
      fdata.append("paymentmethod", PaymentMode);

      const response = await axios.post(
        `${WebsiteAPIurl}withdrawalrequest`,
        fdata,
        {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (PaymentMode && amount && userID) {
        if (response.data.status === "1") {
          NotifyMessageNoReload(response.data.message, "success");

          // ✅ wait until wallet balance updated
          const updatedBalance = await fetchWalletBalance();
          console.log("Updated Balance:", updatedBalance);

          setAmount("");
          setPaymentMode("");
        } else {
          NotifyMessageNoReload(response.data.message, "danger");
        }
      } else {
        NotifyMessageNoReload("Please Select A Payment Methods!", "danger");
      }
    } catch (error) {
      NotifyMessageNoReload("Payment failed. Please try again.", "danger");
      console.error(error);
    } finally {
      // ✅ ab loader sahi se off hoga
      setIsProcessing(false);
    }
  };

  if (isProcessing) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Passbook", pagelink: "passbook" },
            { name: "Withdrawal" },
          ]}
        />

        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="wallet_container">
              <div className="wallet_header WalletHeader">
                <div className="tabs">
                  <button className="tab active">
                    <span className="WithdrawalHeadingTitle">
                      Available Balance
                    </span>
                    {/* <span className="wallettabicon">
                      
                      <AccountBalanceWalletOutlinedIcon />
                    </span> */}
                  </button>
                </div>
                <div className="balance-section">
                  {/* <h2>TOTAL BALANCE</h2> */}
                  <div className="balance-amount">
                    ₹{walletbalance ? walletbalance : "0"}
                  </div>
                </div>
              </div>

              <div className="payment-details-container withdrawalContainer mt-0 ">
                <div className="payment-details-card payment_Detailscard">
                  <div className="  payment-methods">
                    <h3 className="section-title">Payment Method</h3>
                    <RadioGroup
                      className="paymentReadioGroup"
                      value={PaymentMode}
                      onChange={handlePaymentMethodChange}
                    >
                      {PaymentMethod &&
                        PaymentMethod.length > 0 &&
                        PaymentMethod.map((val, index) => (
                          <FormControlLabel
                            key={index}
                            value={val.id}
                            control={<Radio color="primary" />}
                            label={
                              <div className="payment-method">
                                {val.id === "1" ? (
                                  <AccountBalanceIcon className="method-icon" />
                                ) : (
                                  <AccountBalanceWalletIcon className="method-icon" />
                                )}

                                <span>{val.payment_mode}</span>
                              </div>
                            }
                          />
                        ))}
                    </RadioGroup>
                  </div>
                  <div className="withdrawalProceetBox row align-items-center">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                      {" "}
                      <div className="amount-input-container mb-0">
                        <TextField
                          fullWidth
                          label="Enter Withdrawal Amount (₹)"
                          variant="outlined"
                          value={amount}
                          onChange={handleInputChange}
                          placeholder="Enter amount"
                          type="number"
                          //  inputProps={{ maxLength: 5 }}
                          InputProps={{
                            startAdornment: "₹",
                          }}
                          className="amount-input-field withdrawalamounnbox"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                      <button
                        className=" theme-btn btn-style-three submitbtn handleServiceStatus withddrawalBTNProceet"
                        onClick={handlePaymentSubmit}
                        disabled={isProcessing}
                      >
                        Withdrawal Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {RendomTokenfetch && <WithdrawalTransactionDataTable />}
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
